import { useSelector } from 'react-redux'
import { Card, Row, Col, Skeleton } from 'antd'

// Constant

// Components
import PieChart from './PieChart';
import LineCharts from './LineCharts';
import HeatmapChart from './HeatmapChart';

// Handlers
import { REDUX } from '../../../../services/util'

// Styles
import styles from './style.module.css'
import React from 'react';


const DriverChart = () => {

    const drivers = useSelector(REDUX.reduxStoreWrapper('reports.summary'))
    const events = useSelector(REDUX.reduxStoreWrapper('reports.events'))
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.reports'))

    return (
        <div className={styles['container']}>
            <Row gutter={15}>
                <Col span={10}>
                    <Card title={'Overall Score'} >
                        {loading && drivers.length ? <Skeleton active={loading} paragraph={{ rows: 1 }} /> : <PieChart sum={drivers}/>}
                    </Card>
                </Col>
                <Col span={14}>
                    <Card title={'Score Progression Trend'} >
                        {loading && drivers.length ? <Skeleton active={loading} paragraph={{ rows: 1 }} /> : <LineCharts sum={drivers} />}
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Card title={'Event Violation Heatmap'} >
                        {loading && events.length ? <Skeleton active={loading} paragraph={{ rows: 1 }} /> : <HeatmapChart sum={events} />}
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default React.memo(DriverChart)